import React from 'react';
import { searchSteps } from '../../data/approach';
import { Reveal } from '../motion/Reveal';
type ProcessStepsProps = {
  showDetail?: boolean;
};
export function ProcessSteps({
  showDetail = false
}: ProcessStepsProps) {
  return <ol className="grid gap-10 md:grid-cols-4 md:gap-8" data-id="element-346" data-mp="3nix43ndby6rg">
      {searchSteps.map((step, index) => <Reveal as="li" key={step.title} delay={index * 80} className="relative pl-16 md:pl-0 md:pt-16" data-id="element-347" data-mp="3sgyuktd358cy" data-mpi={index}>
          {index < searchSteps.length - 1 && <span aria-hidden="true" className="absolute bottom-[-28px] left-[19.5px] top-[52px] w-px bg-line md:bottom-auto md:left-[52px] md:right-[-20px] md:top-[19.5px] md:h-px md:w-auto" data-id="element-348" data-mp="p089d78xmoqo" />}
          <span className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border border-gold bg-white font-serif text-lg font-semibold text-navy" data-id="element-349" data-mp="f82la8lswrgr">
            {index + 1}
          </span>
          <h3 className="font-serif text-[1.75rem] font-medium leading-tight text-navy" data-id="element-350" data-mp="17s1539fdyo23">{step.title}</h3>
          <p className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-351" data-mp="ogjjbp9lw0mr">{step.summary}</p>
          {showDetail && <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-352" data-mp="ji00vyu816z5">{step.detail}</p>}
        </Reveal>)}
    </ol>;
}